import React from 'react';
import styled from 'styled-components';
import { Paper, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const GlobalDefaultClinicBanner: React.FC = () => {
  return (
    <StyledBanner>
      <Paper>
        <BannerContent>
          <StyledIcon />
          <div>
            <Typography variant="h6" color="primary">
              Healthera Clinic
            </Typography>
            <Typography variant="body2">
              You are currently viewing / editing <strong>Healthera Clinic</strong>
            </Typography>
          </div>
        </BannerContent>
      </Paper>
    </StyledBanner>
  );
};

const StyledBanner = styled.div`
  margin-bottom: 20px;
`;

const StyledIcon = styled(InfoIcon)`
  color: #EB6055;
  margin-top: 3px;
`;

const BannerContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  
  .MuiSvgIcon-root {
    margin-top: 2px;
    flex-shrink: 0;
  }
  
  > div {
    flex: 1;
  }
`;

export default GlobalDefaultClinicBanner; 
